module.exports = __webpack_public_path__ + "static/feather-sprite-cbef33d25b84f027c6e7601fdec1f75a.svg";